document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('form[action^="/cart/add"], form.product-form');
  if (!productForm) return;

  const addBtn = productForm.querySelector('button[type="submit"], .product-form__add-to-cart, .add-to-cart');
  if (!addBtn) return;

  // 🔹 Try to find the existing Shopify Buy It Now button
  const buyNowBtn = document.querySelector('.shopify-payment-button__button--unbranded');

  const productTitle = document.querySelector('.text-block--AMnB0MXhSSFU3S3JVV__product_title_eYVzTU h3');
  const productPrice = document.querySelector('.price-container .price');
  const comparePrice = document.querySelector('.price-container .compare-at-price');

  // 🔹 Create sticky bar
  const stickyBar = document.createElement('div');
  stickyBar.className = 'sticky-add-to-cart';
  stickyBar.innerHTML = `
    <div class="sticky-add-to-cart__inner">
      <div class="sticky-add-to-cart__info">
        <div class="sticky-add-to-cart__title">${productTitle ? productTitle.textContent.trim() : ''}</div>
        <div class="sticky-add-to-cart__price">
          <span class="current">${productPrice ? productPrice.textContent.trim() : ''}</span>
          ${comparePrice ? `<span class="compare">${comparePrice.textContent.trim()}</span>` : ''}
        </div>
      </div>
      <div class="sticky-add-to-cart__buttons">
        <button type="button" class="sticky-add-to-cart__btn">${addBtn.textContent.trim()}</button>
        ${buyNowBtn ? `<button type="button" class="sticky-buy-now-btn">${buyNowBtn.textContent.trim()}</button>` : ''}
      </div>
    </div>
  `;
  document.body.appendChild(stickyBar);

  const stickyAddBtn = stickyBar.querySelector('.sticky-add-to-cart__btn');
  const stickyBuyNowBtn = stickyBar.querySelector('.sticky-buy-now-btn');

  // 🔹 Show/Hide Sticky Bar
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0.1 });
  observer.observe(addBtn);

  // 🔹 Update price dynamically when variant changes
  const priceContainer = document.querySelector('.price-container');
  if (priceContainer) {
    const mo = new MutationObserver(() => {
      const current = stickyBar.querySelector('.current');
      const compare = stickyBar.querySelector('.compare');
      const updatedPrice = document.querySelector('.price-container .price');
      const updatedCompare = document.querySelector('.price-container .compare-at-price');
      if (updatedPrice && current) current.textContent = updatedPrice.textContent.trim();
      if (updatedCompare && compare) compare.textContent = updatedCompare.textContent.trim();
    });
    mo.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  // 🔹 Sticky Add to Cart button click
  stickyAddBtn.addEventListener('click', () => {
    if (!addBtn.disabled) addBtn.click();
  });

  // 🔹 Sticky Buy Now button click (triggers original Buy Now)
  if (stickyBuyNowBtn && buyNowBtn) {
    stickyBuyNowBtn.addEventListener('click', () => {
      buyNowBtn.click();
    });
  }
});






document.addEventListener("DOMContentLoaded", function() {
  const addToCartBtn = document.querySelector(".product-form__submit, .add-to-cart-button");
  const variantInputs = document.querySelectorAll(
    '.product-form__input input[type="radio"], fieldset[data-option-id*="size"] input[type="radio"]'
  );
  const warning = document.querySelector(".size-warning");

  // 1️⃣ Page load par sab variant unselect kar do
  variantInputs.forEach(input => {
    input.checked = false;
  });

  // 2️⃣ Add to Cart click hone par check karo
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function(event) {
      const anySelected = Array.from(variantInputs).some(input => input.checked);

      if (!anySelected) {
        event.preventDefault(); // Stop form submit
        warning.style.display = "block";
        warning.textContent = "Please select a size before adding to cart.";
      } else {
        warning.style.display = "none";
      }
    });
  }

  // 3️⃣ Variant select karne par warning hide kar do
  variantInputs.forEach(input => {
    input.addEventListener("change", function() {
      warning.style.display = "none";
    });
  });
});

// Source - https://stackoverflow.com/questions/62052030/how-can-i-change-the-row-and-colum-background-color-on-hover-a-table-element
// Posted by Erick Storck
// Retrieved 2025-11-06, License - CC BY-SA 4.0



document.addEventListener("DOMContentLoaded", () => {
  // Function to handle hover effect for any table
  function setupHoverEffect(tableSelector) {
    const table = document.querySelector(tableSelector);
    if (!table) return;

    table.addEventListener("mouseover", (e) => {
      if (e.target.tagName === "TD" || e.target.tagName === "TH") {
        const row = e.target.parentElement;
        const colIndex = e.target.cellIndex + 1;

        // Highlight column
        table.querySelectorAll(`td:nth-child(${colIndex}), th:nth-child(${colIndex})`)
          .forEach(cell => cell.classList.add("hovered"));

        // Highlight row
        row.querySelectorAll("td, th").forEach(cell => cell.classList.add("hovered"));
      }
    });

    table.addEventListener("mouseout", () => {
      table.querySelectorAll(".hovered").forEach(cell => cell.classList.remove("hovered"));
    });
  }

  // Apply to both tables
  setupHoverEffect(".size-chart-container");
  setupHoverEffect("#garmentTable2");
});







